/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
//= require rails-ujs
//= require turbolinks
//= require moment
//= require jquery3
//= require toastr
//= require modulejs
//= require popper
//= require activestorage
//= require_tree .

import { I18n } from "i18n-js";
import toastr from 'toastr';
import 'bootstrap';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.css';

import './configurations/index';
import './reports/index';
import './shared/index';
const images = require.context('../images', true)

I18n.defaultLocale = "pt-BR";
I18n.locale = "pt-BR";

toastr.options.timeOut = 5000; // How long the toast will display without user interaction
toastr.options.tapToDismiss = false;
toastr.options.preventDuplicates = true;
toastr.options.preventOpenDuplicates = true;
toastr.options.newestOnTop = true;
toastr.options.maxOpened = 1;

import '../stylesheets/application.scss';
